module.exports = __webpack_public_path__ + "static/media/check.36e17d22.svg";